// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Poppins', 'Poppins Fallback'","fontStyle":"normal"},"className":"__className_d4a78a"};